'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CalendarDialog = require('./CalendarDialog');

var _CalendarDialog2 = _interopRequireDefault(_CalendarDialog);

var _Portal = require('./Portal.js');

var _Portal2 = _interopRequireDefault(_Portal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('./CalendarDialog.css');

var CalendarDialogLink = _react2.default.createClass({
    displayName: 'CalendarDialogLink',

    getInitialState: function getInitialState() {
        return { showConfirm: false };
    },
    showHideConfirm: function showHideConfirm() {
        if (!this.props.request.sendingRequest) {
            this.setState({
                showConfirm: !this.state.showConfirm,
            });
        }
    },
    render: function render() {
        return _react2.default.createElement(
            'span',
            { className: 'ReactCalendarLink', onClick: this.showHideConfirm },
            this.props.children,
            this.state.showConfirm ? _react2.default.createElement(
                _Portal2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'ReactCalendarDialog' },
                    _react2.default.createElement(_CalendarDialog2.default, _extends({}, this.props, {
                        cancel: this.showHideConfirm
                    }))
                )
            ) : ''
        );
    }
});

exports.default = CalendarDialogLink;


/** WEBPACK FOOTER **
 ** ./src/dialogs/CalendarDialogLink.js
 **/